import ImageCropEditor from "./ImageCropEditor";

export default function AvatarCropEditor(props) {
  return (
    <ImageCropEditor
      {...props}
      title="Adjust Profile Picture"
      aspect={1}
      cropShape="round"
      containerClass="aspect-square"
      hint="Drag to reposition. Use the slider or pinch to zoom."
    />
  );
}
